import $ from 'jquery';
import Treasure from 'td-js-sdk';

// TD接続情報
const client = {
    connect: {
        writeKey: process.env.MIX_TREASURE_WRITE_KEY,
        database: process.env.MIX_TREASURE_DATA_DB_USER,
        startInSignedMode: true,
        host: window.location.hostname, // ローカル確認時はコメントアウト
    },
};

// テーブル名
const TABLE_ACTION = 'site_action';

/**
 * ページ遷移
 * @param hasLink
 * @param href
 * @returns {null}
 */
const linkPage = (hasLink, href) => {
    // リンクじゃない場合は何もしない
    if (!hasLink) {
        return null;
    }

    // ページ遷移
    window.location.href = href;
}

/**
 * CVボタンの計測
 *
 * adListing() の定義は
 * resources/views/user/partials/tags/_adlisting.blade.php にあります
 */
$(() => {
    $(document).on('click', '[data-ct]', e => {
        const kind = $(e.currentTarget).data('ct');
        if (!kind.length) {
            return;
        }

        // リンクの場合は遷移しないようにイベントを止める
        const href = e.currentTarget.getAttribute('href');
        const hasLink = e.currentTarget.tagName === 'A' && href.length > 0;
        if (hasLink) {
            e.preventDefault();
        }

        try {
            // CV ボタンの押下を Analytics へ通知（analytics.jsのみ）
            if (typeof ga === 'function') {
                ga('send', 'event', 'web-tsuku', `${kind}-tap`);
            }
            // Adwords へ通知
            adListing(kind);

            if (
                typeof dataLayer === 'object' &&
                typeof dataLayer.push === 'function'
            ) {
                dataLayer.push({
                    event: 'trackevent',
                    eventCategory: 'web-tsuku',
                    eventAction: `${kind}-tap`,
                });
            }

            // TreasureDate へ通知
            const treasureData = document.getElementById('treasure_data');
            const action = {
                ...JSON.parse(treasureData.dataset.action), ...{
                    'action_type': 'click',
                    'action_detail': kind
                }
            };
            const td = new Treasure(client.connect);
            td.trackEvent(TABLE_ACTION, action, () => {
                // 送信成功後にページ遷移
                linkPage(hasLink, href);
            });
        } catch (e) {
            // ページ遷移
            linkPage(hasLink, href);
            throw e;
        }
    });
});
